export default __webpack_public_path__ + "static/taskdefinition2-f7d94b6a1af67b9497eb6815340329c0.png";